// var env = process.env.NODE_ENV || 'development';
var env = 'production';

var config = {
  development: require('./config/dev.js'),
  production: require('./config/prod.js')
};

// console.log(env);
module.exports = config[env];